import { render } from "./AddApprovisionnement.vue?vue&type=template&id=d1ff8c80&scoped=true&ts=true"
import script from "./AddApprovisionnement.vue?vue&type=script&lang=ts"
export * from "./AddApprovisionnement.vue?vue&type=script&lang=ts"

import "./AddApprovisionnement.vue?vue&type=style&index=0&id=d1ff8c80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ff8c80"]])

export default __exports__